import routes from './cccc';

export default routes;
